import * as React from 'react';
import classNames from 'classnames';
import { Text } from './text';
import { linkPropDefs } from './link.props';
const Link = React.forwardRef((props, forwardedRef) => {
    const { children, className, asChild = false, underline = linkPropDefs.underline.default, ...linkProps } = props;
    return (React.createElement(Text, { ...linkProps, ref: forwardedRef, asChild: true, className: classNames('rt-reset', 'rt-Link', className, `rt-underline-${underline}`) }, asChild ? children : React.createElement("a", null, children)));
});
Link.displayName = 'Link';
export { Link };
//# sourceMappingURL=link.js.map